var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5744 4.57551C14.8919 4.25798 14.8919 3.74317 14.5744 3.42565C14.2568 3.10812 13.742 3.10812 13.4245 3.42565L9 7.85013L4.57551 3.42565C4.25798 3.10812 3.74317 3.10812 3.42565 3.42565C3.10812 3.74317 3.10812 4.25798 3.42565 4.57551L7.85013 9L3.42565 13.4245C3.10812 13.742 3.10812 14.2568 3.42565 14.5744C3.74317 14.8919 4.25799 14.8919 4.57551 14.5744L9 10.1499L13.4245 14.5744C13.742 14.8919 14.2568 14.8919 14.5744 14.5744C14.8919 14.2568 14.8919 13.742 14.5744 13.4245L10.1499 9L14.5744 4.57551Z",
    fill: "#78829D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.caff2978eb59c5b7df4d56343b033f6c.svg";
export { ForwardRef as ReactComponent };